import * as React from 'react';
import { Button, notification } from 'antd';
import { VendorService } from '../../../service/VendorService';
import {
  vendorObject,
  vendorErrorObject,
  VendorNode,
  VendorError,
} from './constants';
import { VendorForm } from './VendorForm';
import { forEach } from 'lodash';

export class AddVendor extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      vendor: props.vendor || JSON.parse(JSON.stringify(vendorObject)),
      error: { ...vendorErrorObject },
      buttonDisabled: false,
    };
  }

  vendorService = new VendorService();

  componentWillReceiveProps(nextProps: Props) {
    this.setState({
      vendor: nextProps.vendor || JSON.parse(JSON.stringify(vendorObject)),
    });
  }

  onChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | { target: { name: string; value: string | number | boolean | null } },
  ) => {
    const vendor = { ...this.state.vendor };
    vendor[e.target.name] = e.target.value;
    this.setState({ vendor });
  };

  checkError = () => {
    const error = { ...this.state.error };
    let isError = false;
    const requiredFields = ['name', 'contactPersonName', 'contactNo', 'state'];
    forEach(this.state.vendor, (value, key) => {
      if (
        typeof value === 'string' &&
        requiredFields.indexOf(key) > -1 &&
        !value.trim()
      ) {
        isError = true;
        error[key] = `This is a Required field`;
      } else if (!value && requiredFields.indexOf(key) > -1) {
        isError = true;
        error[key] = `This is a Required field`;
      } else if (requiredFields.indexOf(key) > -1) {
        error[key] = '';
      }
    });
    this.setState({ error });
    return isError;
  };

  saveVendor = () => {
    if (this.checkError()) {
      return;
    }
    this.setState({ buttonDisabled: true });
    this.vendorService?.addVendor(
      this.state.vendor,
      (response) => {
        this.setState({ buttonDisabled: false });
        notification.success({
          message: 'Vendor ' + this.state.vendor.id ? 'Updated' : 'Added',
          description: `Vendor named ${
            this.state.vendor.name
          } was successfuly ${this.state.vendor.id ? 'Updated' : 'Added'}`,
        });
        this.props.handleTabChange?.('1');
      },
      (error) =>
        notification.error({
          message:
            'Vendor ' + this.state.vendor.id ? 'Update Error' : 'Add Error',
          description: JSON.stringify(error),
        }),
    );
  };

  clear = () => {
    this.setState({
      vendor: JSON.parse(JSON.stringify(vendorObject)),
      error: { ...vendorErrorObject },
    });
  };

  render() {
    return (
      <div>
        <VendorForm
          value={this.state.vendor}
          error={this.state.error}
          onChange={this.onChange}
        />
        <Button
          type="dashed"
          onClick={this.clear}
          children="Clear"
          style={{ width: '50%' }}
        />
        <Button
          type="primary"
          onClick={this.saveVendor}
          children="Submit"
          style={{ width: '50%' }}
          disabled={this.state.buttonDisabled}
        />
      </div>
    );
  }
}

interface Props {
  vendor?: VendorNode;
  handleTabChange?: (key) => void;
}

interface State {
  vendor: VendorNode;
  error: VendorError;
  buttonDisabled: boolean;
}
